import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { DrawerOpenEvent } from '@theme/theme-drawer';


/* =========================================================
   PREMIUM ADDED TO CART POPUP
========================================================= */

let premiumCartToastTimer = null;

function formatCartMoney(cents) {
  const currency =
    window.Shopify?.currency?.active ||
    'INR';

  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format((Number(cents) || 0) / 100);
  } catch {
    return `₹${((Number(cents) || 0) / 100).toFixed(2)}`;
  }
}


function createPremiumCartToast() {
  let toast =
    document.getElementById('premium-cart-toast');

  if (toast) return toast;


  /* -----------------------------
     CSS
  ----------------------------- */

  const style =
    document.createElement('style');

  style.id =
    'premium-cart-toast-style';

  style.textContent = `

    #premium-cart-toast,
    #premium-cart-toast * {
      box-sizing: border-box;
    }


    #premium-cart-toast {
      position: fixed;

      left: 50%;
      bottom: 18px;

      z-index: 99999999;

      width: min(
        570px,
        calc(100vw - 28px)
      );

      min-height: 58px;

      display: grid;

      grid-template-columns:
        minmax(0, 1.35fr)
        1px
        minmax(145px, .9fr)
        110px
        30px;

      align-items: center;

      column-gap: 13px;

      padding:
        6px
        9px
        6px
        7px;

      border:
        1px solid
        rgba(255,255,255,.08);

      border-radius: 10px;

      background:
        linear-gradient(
          115deg,
          #1c1d1f 0%,
          #111214 48%,
          #17181a 100%
        );

      color: #ffffff;

      box-shadow:
        0 15px 40px rgba(0,0,0,.28),
        0 3px 10px rgba(0,0,0,.16);

      opacity: 0;

      visibility: hidden;

      pointer-events: none;

      transform:
        translate(-50%, 22px)
        scale(.985);

      transition:
        opacity .28s ease,
        transform .42s cubic-bezier(.16,1,.3,1),
        visibility .28s ease;
    }


    #premium-cart-toast.is-visible {
      opacity: 1;

      visibility: visible;

      pointer-events: auto;

      transform:
        translate(-50%,0)
        scale(1);
    }


    /* PRODUCT
    ===================================== */

    #premium-cart-toast
    .pct-product {
      min-width: 0;

      display: flex;

      align-items: center;

      gap: 9px;
    }


    #premium-cart-toast
    .pct-image-wrap {
      width: 48px;
      height: 48px;

      flex: 0 0 48px;

      overflow: hidden;

      border-radius: 6px;

      background: #292a2d;
    }


    #premium-cart-toast
    .pct-image {
      display: block;

      width: 100%;
      height: 100%;

      object-fit: cover;
    }


    #premium-cart-toast
    .pct-product-info {
      min-width: 0;
    }


    #premium-cart-toast
    .pct-title {
      max-width: 100%;

      overflow: hidden;

      white-space: nowrap;

      text-overflow: ellipsis;

      color: #ffffff;

      font-family: inherit;

      font-size: 10px;

      font-weight: 650;

      line-height: 1.25;
    }


    #premium-cart-toast
    .pct-meta {
      display: flex;

      align-items: center;

      gap: 6px;

      margin-top: 6px;
    }


    #premium-cart-toast
    .pct-variant {
      min-width: 20px;

      min-height: 17px;

      display: inline-flex;

      align-items: center;

      justify-content: center;

      padding:
        2px
        5px;

      border-radius: 4px;

      background:
        rgba(255,255,255,.075);

      color:
        rgba(255,255,255,.68);

      font-size: 8px;

      line-height: 1;

      font-weight: 600;
    }


    #premium-cart-toast
    .pct-variant:empty {
      display: none;
    }


    #premium-cart-toast
    .pct-price {
      color: #ffffff;

      font-size: 9px;

      font-weight: 700;

      line-height: 1;
    }


    /* DIVIDER
    ===================================== */

    #premium-cart-toast
    .pct-divider {
      width: 1px;

      height: 31px;

      background:
        rgba(255,255,255,.10);
    }


    /* SUCCESS
    ===================================== */

    #premium-cart-toast
    .pct-success {
      min-width: 0;

      display: flex;

      align-items: center;

      gap: 8px;
    }


    #premium-cart-toast
    .pct-check {
      width: 23px;
      height: 23px;

      flex: 0 0 23px;

      display: flex;

      align-items: center;

      justify-content: center;

      color: #dfb66a;
    }


    #premium-cart-toast
    .pct-check svg {
      display: block;

      width: 23px;
      height: 23px;

      fill: none;

      stroke: currentColor;

      stroke-width: 1.45;

      stroke-linecap: round;

      stroke-linejoin: round;
    }


    #premium-cart-toast
    .pct-success-content {
      min-width: 0;
    }


    #premium-cart-toast
    .pct-success-title {
      color: #ffffff;

      font-size: 8px;

      font-weight: 650;

      line-height: 1.2;
    }


    #premium-cart-toast
    .pct-success-subtitle {
      margin-top: 3px;

      color:
        rgba(255,255,255,.50);

      font-size: 5.5px;

      font-weight: 400;

      line-height: 1.3;

      white-space: nowrap;
    }


    /* VIEW CART
    ===================================== */

    #premium-cart-toast
    .pct-view-cart {
      appearance: none;

      width: 100%;

      min-height: 31px;

      display: flex;

      align-items: center;

      justify-content: center;

      gap: 6px;

      padding:
        6px
        8px;

      border:
        1px solid
        rgba(255,235,198,.38);

      border-radius: 5px;

      background:
        linear-gradient(
          135deg,
          #f1d39b,
          #e6bd74
        );

      color: #17130d;

      box-shadow:
        inset 0 1px
        rgba(255,255,255,.35);

      font-family: inherit;

      font-size: 7px;

      font-weight: 750;

      line-height: 1;

      cursor: pointer;

      transition:
        transform .22s ease,
        filter .22s ease;
    }


    #premium-cart-toast
    .pct-view-cart:hover {
      transform: translateY(-1px);

      filter: brightness(1.04);
    }


    #premium-cart-toast
    .pct-view-cart svg {
      width: 11px;
      height: 11px;

      flex: 0 0 11px;

      fill: none;

      stroke: currentColor;

      stroke-width: 1.5;

      stroke-linecap: round;

      stroke-linejoin: round;
    }


    /* CLOSE
    ===================================== */

    #premium-cart-toast
    .pct-close {
      appearance: none;

      width: 25px;
      height: 25px;

      display: flex;

      align-items: center;

      justify-content: center;

      padding: 0;

      border:
        1px solid
        rgba(222,181,105,.20);

      border-radius: 50%;

      background:
        rgba(255,255,255,.01);

      color: #d7ac61;

      cursor: pointer;

      transition:
        background .2s ease,
        transform .2s ease;
    }


    #premium-cart-toast
    .pct-close:hover {
      background:
        rgba(222,181,105,.07);

      transform: rotate(5deg);
    }


    #premium-cart-toast
    .pct-close svg {
      width: 11px;
      height: 11px;

      fill: none;

      stroke: currentColor;

      stroke-width: 1.5;

      stroke-linecap: round;
    }



    /* =====================================================
       MOBILE
    ===================================================== */

    @media screen and (max-width: 749px) {

      #premium-cart-toast {
        bottom: 10px;

        width:
          calc(100vw - 18px);

        min-height: auto;

        grid-template-columns:
          minmax(0,1fr)
          auto;

        gap: 9px;

        padding: 9px;

        border-radius: 9px;
      }


      #premium-cart-toast
      .pct-product {
        grid-column:
          1 / -1;

        padding-right: 34px;
      }


      #premium-cart-toast
      .pct-image-wrap {
        width: 48px;
        height: 48px;

        flex-basis: 48px;
      }


      #premium-cart-toast
      .pct-title {
        font-size: 11px;
      }


      #premium-cart-toast
      .pct-price {
        font-size: 9.5px;
      }


      #premium-cart-toast
      .pct-variant {
        font-size: 8.5px;
      }


      #premium-cart-toast
      .pct-divider {
        display: none;
      }


      #premium-cart-toast
      .pct-success {
        gap: 7px;
      }


      #premium-cart-toast
      .pct-success-title {
        font-size: 9px;
      }


      #premium-cart-toast
      .pct-success-subtitle {
        display: none;
      }


      #premium-cart-toast
      .pct-check {
        width: 22px;
        height: 22px;

        flex-basis: 22px;
      }


      #premium-cart-toast
      .pct-check svg {
        width: 22px;
        height: 22px;
      }


      #premium-cart-toast
      .pct-view-cart {
        width: auto;

        min-height: 35px;

        padding:
          7px
          11px;

        font-size: 8px;
      }


      #premium-cart-toast
      .pct-close {
        position: absolute;

        right: 9px;
        top: 9px;

        width: 26px;
        height: 26px;

        color:
          rgba(255,255,255,.63);

        border-color:
          rgba(255,255,255,.11);
      }

    }


    @media
    (prefers-reduced-motion: reduce) {

      #premium-cart-toast {
        transition: none;
      }

    }

  `;

  document.head.appendChild(style);


  /* -----------------------------
     HTML
  ----------------------------- */

  toast =
    document.createElement('div');

  toast.id =
    'premium-cart-toast';

  toast.innerHTML = `

    <div class="pct-product">

      <div class="pct-image-wrap">

        <img
          class="pct-image"
          alt=""
        >

      </div>


      <div class="pct-product-info">

        <div class="pct-title">
          Product
        </div>


        <div class="pct-meta">

          <span class="pct-variant"></span>

          <span class="pct-price"></span>

        </div>

      </div>

    </div>


    <div class="pct-divider"></div>


    <div class="pct-success">

      <span class="pct-check">

        <svg
          viewBox="0 0 26 26"
          aria-hidden="true"
        >
          <circle
            cx="13"
            cy="13"
            r="9.5"
          ></circle>

          <path
            d="M9 13.1l2.5 2.5 5.4-5.7"
          ></path>
        </svg>

      </span>


      <div class="pct-success-content">

        <div class="pct-success-title">
          Added to cart
        </div>

        <div class="pct-success-subtitle">
          Item has been added to your cart
        </div>

      </div>

    </div>


    <button
      class="pct-view-cart"
      type="button"
    >

      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M6.5 8.5h11l-.6 11h-9.8l-.6-11Z"
        ></path>

        <path
          d="M9 8.5V6.8a3 3 0 0 1 6 0v1.7"
        ></path>
      </svg>

      <span class="pct-view-text">
        View Cart
      </span>

    </button>


    <button
      class="pct-close"
      type="button"
      aria-label="Close"
    >

      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M7 7l10 10"></path>
        <path d="M17 7L7 17"></path>
      </svg>

    </button>

  `;


  document.body.appendChild(toast);


  toast
    .querySelector('.pct-close')
    ?.addEventListener(
      'click',
      () => {

        toast.classList.remove(
          'is-visible'
        );

      }
    );


  toast
    .querySelector('.pct-view-cart')
    ?.addEventListener(
      'click',
      () => {

        toast.classList.remove(
          'is-visible'
        );

        const drawer =
          document.querySelector(
            '#cart-drawer'
          );

        if (
          drawer &&
          typeof drawer.open ===
            'function'
        ) {
          drawer.open();
          return;
        }

        window.location.href =
          '/cart';

      }
    );


  return toast;
}


function showPremiumCartToast(
  item,
  cartCount
) {

  if (!item) return;


  const toast =
    createPremiumCartToast();


  const image =
    toast.querySelector(
      '.pct-image'
    );

  const title =
    toast.querySelector(
      '.pct-title'
    );

  const variant =
    toast.querySelector(
      '.pct-variant'
    );

  const price =
    toast.querySelector(
      '.pct-price'
    );

  const viewText =
    toast.querySelector(
      '.pct-view-text'
    );


  /* IMAGE */

  if (image) {

    if (item.image) {

      image.src =
        item.image;

      image.alt =
        item.product_title ||
        item.title ||
        '';

    } else {

      image.removeAttribute(
        'src'
      );

    }

  }


  /* TITLE */

  if (title) {

    title.textContent =
      item.product_title ||
      item.title ||
      'Product';

  }


  /* VARIANT / SIZE */

  if (variant) {

    variant.textContent =
      item.variant_title &&
      item.variant_title !==
        'Default Title'
        ? item.variant_title
        : '';

  }


  /* PRICE */

  if (price) {

    price.textContent =
      formatCartMoney(
        item.final_price ??
        item.discounted_price ??
        item.price ??
        0
      );

  }


  /* CART COUNT */

  if (viewText) {

    viewText.textContent =
      `View Cart (${cartCount})`;

  }


  /* ANIMATION */

  toast.classList.remove(
    'is-visible'
  );

  void toast.offsetWidth;


  requestAnimationFrame(
    () => {

      toast.classList.add(
        'is-visible'
      );

    }
  );


  if (premiumCartToastTimer) {

    clearTimeout(
      premiumCartToastTimer
    );

  }


  premiumCartToastTimer =
    setTimeout(
      () => {

        toast.classList.remove(
          'is-visible'
        );

      },
      5500
    );
}



/**
 * A custom element that manages cart drawer behavior within a `<theme-drawer>`.
 *
 * @extends {Component}
 */

class CartDrawerComponent extends Component {

  /** @type {number} */
  #summaryThreshold = 0.5;


  /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */

  get #themeDrawer() {

    return /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */ (
      this.closest(
        'theme-drawer'
      )
    );

  }


  /** @type {HTMLDialogElement | null} */

  get #dialog() {

    return this.closest(
      'dialog'
    );

  }


  connectedCallback() {

    super.connectedCallback();

    document.addEventListener(
      StandardEvents.cartLinesUpdate,
      this.#handleCartLinesUpdate
    );

    this.#themeDrawer?.addEventListener(
      DrawerOpenEvent.eventName,
      this.#handleDrawerOpen
    );


    if (
      this.#themeDrawer?.hasAttribute(
        'open'
      )
    ) {

      this.#handleDrawerOpen();

    }

  }


  disconnectedCallback() {

    super.disconnectedCallback();

    document.removeEventListener(
      StandardEvents.cartLinesUpdate,
      this.#handleCartLinesUpdate
    );

    this.#themeDrawer?.removeEventListener(
      DrawerOpenEvent.eventName,
      this.#handleDrawerOpen
    );

  }


  /**
   * Handles drawer opening
   */

  #handleDrawerOpen = () => {

    this.#updateStickyState();


    customElements
      .whenDefined(
        'shopify-payment-terms'
      )
      .then(() => {

        const cta =
          this.querySelector(
            'shopify-payment-terms'
          )
            ?.shadowRoot
            ?.querySelector(
              '#shopify-installments-cta'
            );


        cta?.addEventListener(
          'click',
          () =>
            this.#themeDrawer
              ?.close(),
          {
            once: true,
          }
        );

      });

  };


  /**
   * Native cart update listener
   *
   * @param {import('@shopify/events').CartLinesUpdateEvent} event
   */

  #handleCartLinesUpdate =
    (event) => {

      const shouldAutoOpen =
        this.hasAttribute(
          'auto-open'
        ) &&
        event.action === 'add' &&
        !this.#themeDrawer?.isOpen;


      const sourceModal =
        /** @type {HTMLDialogElement | null} */ (
          event.target instanceof
          Element
            ? event.target.closest(
                'dialog:modal'
              )
            : null
        );


      if (
        shouldAutoOpen &&
        !sourceModal &&
        !this.#isCartEmpty()
      ) {

        this.#themeDrawer?.open();

      }


      event.promise
        ?.then(
          ({
            cart,
            detail,
          }) => {

            /*
              ===========================
              PREMIUM TOAST
              ===========================
            */

            if (
              event.action ===
                'add' &&
              !detail?.didError
            ) {

              const items =
                detail?.items ||
                cart?.items ||
                [];


              const addedVariantId =
                event.lines?.[0]
                  ?.merchandiseId;


              let addedItem =
                null;


              if (
                addedVariantId
              ) {

                addedItem =
                  items.find(
                    (item) =>
                      String(
                        item.variant_id
                      ) ===
                      String(
                        addedVariantId
                      )
                  );

              }


              if (
                !addedItem &&
                items.length
              ) {

                addedItem =
                  items[0];

              }


              const cartCount =
                items.reduce(
                  (
                    total,
                    item
                  ) =>
                    total +
                    Number(
                      item.quantity ||
                        0
                    ),
                  0
                );


              if (addedItem) {

                showPremiumCartToast(
                  addedItem,
                  cartCount
                );

              }

            }


            /*
              ===========================
              ORIGINAL DRAWER LOGIC
              ===========================
            */

            const settle = () =>
              requestAnimationFrame(
                () =>
                  this.#updateStickyState()
              );


            if (
              !shouldAutoOpen ||
              detail?.didError
            ) {

              settle();

              return;

            }


            const openAndSettle =
              () => {

                if (
                  !this.#themeDrawer
                    ?.isOpen
                ) {

                  this.#themeDrawer?.open();

                }

                settle();

              };


            if (
              sourceModal?.open
            ) {

              sourceModal.addEventListener(
                'close',
                openAndSettle,
                {
                  once: true,
                }
              );

            } else {

              openAndSettle();

            }

          }
        )
        .catch(
          (error) => {

            if (
              error?.name !==
              'AbortError'
            ) {

              console.warn(
                '[cart-drawer] Event promise rejected:',
                error
              );

            }

          }
        );

    };


  #isCartEmpty() {

    return Boolean(
      this.querySelector(
        '.cart-drawer--empty'
      )
    );

  }


  #updateStickyState() {

    const dialog =
      this.#dialog;

    if (!dialog) return;


    const content =
      dialog.querySelector(
        '.cart-drawer__content'
      );


    const summary =
      dialog.querySelector(
        '.cart-drawer__summary'
      );


    if (
      !content ||
      !summary
    ) {

      dialog.setAttribute(
        'cart-summary-sticky',
        'false'
      );

      return;

    }


    const drawerHeight =
      dialog
        .getBoundingClientRect()
        .height;


    const summaryHeight =
      summary
        .getBoundingClientRect()
        .height;


    const ratio =
      summaryHeight /
      drawerHeight;


    dialog.setAttribute(
      'cart-summary-sticky',
      ratio >
        this.#summaryThreshold
        ? 'false'
        : 'true'
    );

  }

}


if (
  !customElements.get(
    'cart-drawer-component'
  )
) {

  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );

}